// // ============================================================
// // src/components/Appointment.js
// // ✅ Past slots disabled
// // ✅ Hospital doctors shown from DB when hospitalId exists
// // ✅ No doctors shown for PearlSmile (no hospitalId)
// // ============================================================
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import api from "../utils/api";
// import { useHospital } from "../context/HospitalContext";

// const MAX_SLOTS = 10;

// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];
// const ALL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots);

// // ✅ Disable past time slots for today
// function isSlotPast(dateISO, timeStr) {
//   const todayISO = localISO(new Date());
//   if (dateISO !== todayISO) return false;
//   const now = new Date();
//   const [timePart, meridiem] = timeStr.split(" ");
//   const [hourStr, minStr] = timePart.split(":");
//   let hour = parseInt(hourStr);
//   const min = parseInt(minStr);
//   if (meridiem === "PM" && hour !== 12) hour += 12;
//   if (meridiem === "AM" && hour === 12) hour = 0;
//   const slotTime = new Date();
//   slotTime.setHours(hour, min, 0, 0);
//   return slotTime <= now;
// }

// const SERVICES = [
//   "General Checkup & Cleaning",
//   "Teeth Whitening",
//   "Dental Implants",
//   "Root Canal",
//   "Orthodontics / Invisalign",
//   "Cosmetic Dentistry",
//   "Pediatric Dentistry",
//   "Emergency Care",
//   "Other",
// ];

// const CSS = `
// .appt-outer { display:grid; grid-template-columns:1fr 1.35fr; gap:72px; align-items:start; }
// .appt-left-info { display:flex; flex-direction:column; gap:0; }
// .appt-card { background:#fff; border-radius:20px; box-shadow:0 4px 32px rgba(0,0,0,.08); overflow:hidden; }
// .appt-card-header { background:linear-gradient(135deg,#0a1628 0%,#0d7377 100%); padding:22px 28px 18px; display:flex; align-items:center; gap:12px; }
// .appt-card-header-icon { width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0; }
// .appt-card-header-text { flex:1;min-width:0; }
// .appt-card-title { font-size:16px;font-weight:800;color:#fff;margin:0; }
// .appt-card-sub { font-size:11px;color:rgba(255,255,255,.7);margin-top:2px; }
// .appt-section { padding:20px 24px 0; }
// .appt-section:last-child { padding-bottom:24px; }
// .appt-section-label { font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;margin-bottom:10px;display:flex;align-items:center;gap:6px; }
// .appt-section-label-dot { width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#0d7377,#14a0a5);color:#fff;font-size:9px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
// .appt-divider { height:1px;background:#f1f5f9;margin:0 24px; }
// .appt-form-grid { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
// .appt-inp-wrap { display:flex;flex-direction:column;gap:4px; }
// .appt-inp-wrap.full { grid-column:1/-1; }
// .appt-inp-label { font-size:11px;font-weight:600;color:#475569; }
// .appt-inp { padding:10px 12px;border-radius:8px;border:1.5px solid #e2e8f0;font-size:13px;font-family:"DM Sans",sans-serif;outline:none;transition:border-color .2s;background:#f8fafc;width:100%;box-sizing:border-box; }
// .appt-inp:focus { border-color:#0d7377;background:#fff; }
// .appt-textarea { resize:vertical;min-height:72px; }
// .appt-date-strip-wrap { position:relative; }
// .appt-date-strip { display:flex;gap:0;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;border:1.5px solid #e2e8f0;border-radius:12px;background:#f8fafc;overflow:hidden; }
// .appt-date-strip::-webkit-scrollbar { display:none; }
// .appt-date-pill { flex-shrink:0;scroll-snap-align:start;padding:12px 16px;cursor:pointer;text-align:center;min-width:90px;border-right:1px solid #e2e8f0;transition:background .15s;font-family:"DM Sans",sans-serif; }
// .appt-date-pill:last-child { border-right:none; }
// .appt-date-pill:hover { background:rgba(13,115,119,.05); }
// .appt-date-pill.active { background:#0d7377; }
// .appt-date-day { font-size:13px;font-weight:700;color:#1e293b; }
// .appt-date-avail { font-size:10px;color:#16a34a;font-weight:600;margin-top:3px; }
// .appt-date-pill.active .appt-date-day { color:#fff; }
// .appt-date-pill.active .appt-date-avail { color:rgba(255,255,255,.85); }
// .appt-date-scroll-hint { font-size:10px;color:#94a3b8;margin-top:5px;text-align:right; }
// .appt-selected-date-bar { background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:9px 14px;font-size:13px;font-weight:700;color:#1e293b;margin-bottom:14px;display:flex;align-items:center;justify-content:space-between; }
// .appt-selected-date-bar span { color:#0d7377;font-size:11px;font-weight:600; }
// .appt-period-hdr { display:flex;align-items:center;gap:8px;margin:14px 0 10px;font-size:13px;font-weight:700;color:#1e293b; }
// .appt-period-count { background:#f1f5f9;border:1px solid #e2e8f0;border-radius:20px;padding:2px 10px;font-size:10px;color:#64748b;font-weight:600; }
// .appt-slots-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:8px; }
// .appt-slot { padding:10px 6px;border-radius:8px;border:1.5px solid #0d7377;background:#fff;cursor:pointer;text-align:center;transition:all .15s;font-family:"DM Sans",sans-serif; }
// .appt-slot:hover:not(.disabled) { background:#0d7377;border-color:#0d7377; }
// .appt-slot:hover:not(.disabled) .appt-slot-time,.appt-slot:hover:not(.disabled) .appt-slot-left { color:#fff; }
// .appt-slot.selected { background:#0d7377;border-color:#0d7377; }
// .appt-slot.selected .appt-slot-time,.appt-slot.selected .appt-slot-left { color:#fff; }
// .appt-slot.disabled { border-color:#e2e8f0;background:#f8fafc;cursor:not-allowed;opacity:.4; }
// .appt-slot-time { font-size:12px;font-weight:700;color:#0d7377; }
// .appt-slot.disabled .appt-slot-time { color:#94a3b8;text-decoration:line-through; }
// .appt-slot-left { font-size:9px;margin-top:3px;color:#64748b; }
// .appt-slot-left.full { color:#dc2626;font-weight:700; }
// .appt-slot-left.low  { color:#d97706;font-weight:700; }
// .appt-slot-left.ok   { color:#16a34a;font-weight:600; }
// .appt-slot-left.past { color:#94a3b8;font-style:italic; }
// .appt-submit { width:100%;padding:14px;background:linear-gradient(135deg,#25d366,#128c7e);border:none;border-radius:10px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;font-weight:700;color:#fff;font-family:"DM Sans",sans-serif;transition:opacity .2s;margin-top:4px; }
// .appt-submit:hover { opacity:.92; }
// .appt-submit:disabled { opacity:.6;cursor:not-allowed; }
// @keyframes apptPulse { 0%,100%{opacity:1}50%{opacity:.45} }
// .appt-skel { border-radius:8px;background:#e2e8f0;animation:apptPulse 1.5s ease-in-out infinite; }
// .appt-doc-card { padding:12px 14px;border-radius:12px;display:flex;align-items:center;gap:12px;border:1px solid #e5e7eb;background:#f8fafc;margin-bottom:8px; }
// @media(max-width:1024px){.appt-outer{gap:48px;}}
// @media(max-width:860px){.appt-outer{grid-template-columns:1fr!important;gap:32px!important;}.appt-card{border-radius:16px;}.appt-card-header{padding:18px 20px 14px;}.appt-section{padding:16px 18px 0;}.appt-section:last-child{padding-bottom:18px;}.appt-divider{margin:0 18px;}}
// @media(max-width:600px){.appt-card-header{padding:14px 16px 12px;}.appt-card-title{font-size:14px;}.appt-section{padding:14px 14px 0;}.appt-section:last-child{padding-bottom:16px;}.appt-divider{margin:0 14px;}.appt-form-grid{grid-template-columns:1fr!important;}.appt-date-pill{min-width:72px;padding:10px 10px;}.appt-date-day{font-size:12px;}.appt-slots-grid{grid-template-columns:repeat(3,1fr)!important;gap:6px;}.appt-slot{padding:9px 4px;}.appt-slot-time{font-size:11px;}.appt-submit{font-size:14px;padding:13px;}}
// @media(max-width:380px){.appt-slots-grid{grid-template-columns:repeat(2,1fr)!important;}.appt-card-header-icon{width:34px;height:34px;font-size:16px;}}
// `;

// export default function Appointment({ showToast }) {
//   const { hospital } = useHospital();
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: localISO(new Date()),
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);
//   const [slotCounts, setSlotCounts] = useState({});
//   const [slotsLoaded, setSlotsLoaded] = useState(false);
//   const stripRef = useRef(null);

//   // ✅ Auto-refresh past slots every minute
//   const [, setTick] = useState(0);
//   useEffect(() => {
//     const t = setInterval(() => setTick((n) => n + 1), 60000);
//     return () => clearInterval(t);
//   }, []);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const getBooked = (date, time) => slotCounts[`${date}|${time}`] || 0;
//   const getLeft = (date, time) =>
//     Math.max(0, MAX_SLOTS - getBooked(date, time));
//   const isFull = (date, time) => getLeft(date, time) === 0;
//   const isDisabled = (date, time) =>
//     isSlotPast(date, time) || isFull(date, time);
//   const totalAvail = (date) =>
//     ALL_SLOTS.filter((t) => !isDisabled(date, t)).length;

//   // ✅ Fetch doctors — only from DB when hospitalId exists
//   useEffect(() => {
//     const hospitalId = hospital?._id || "";

//     if (!hospitalId) {
//       // No hospitalId (PearlSmile) — no doctors to show
//       setDoctors([]);
//       setDoctorsLoaded(true);
//       return;
//     }

//     // For registered hospitals — fetch from DB filtered by hospitalId
//     let iv;
//     const go = () => {
//       fetch(
//         `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/doctors?hospitalId=${hospitalId}`,
//       )
//         .then((r) => (r.ok ? r.json() : []))
//         .then((data) => {
//           if (Array.isArray(data)) {
//             setDoctors(data.filter((d) => !d.isAdmin));
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {
//           setDoctorsLoaded(true);
//         });
//     };
//     go();
//     iv = setInterval(go, 30000);
//     return () => clearInterval(iv);
//   }, [hospital?._id]);

//   // ✅ Fetch slot counts filtered by hospitalId
//   const fetchSlotCounts = useCallback(async () => {
//     try {
//       const hospitalId = hospital?._id || "";
//       const url = hospitalId
//         ? `/appointments/slots?hospitalId=${hospitalId}`
//         : `/appointments/slots`;
//       const data = await api.get(url);
//       if (data && typeof data === "object" && !Array.isArray(data)) {
//         setSlotCounts(data);
//       }
//     } catch (_) {
//     } finally {
//       setSlotsLoaded(true);
//     }
//   }, [hospital?._id]);

//   useEffect(() => {
//     fetchSlotCounts();
//     const t = setInterval(fetchSlotCounts, 20000);
//     return () => clearInterval(t);
//   }, [fetchSlotCounts]);

//   useEffect(() => {
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill)
//       pill.scrollIntoView({
//         behavior: "smooth",
//         block: "nearest",
//         inline: "center",
//       });
//   }, [form.date]);

//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     if (form.time && isDisabled(form.date, form.time)) {
//       alert("This time slot is not available. Please choose another.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", {
//         ...form,
//         hospitalId: hospital?._id || null,
//       });
//       if (form.time) {
//         const key = `${form.date}|${form.time}`;
//         setSlotCounts((prev) => ({ ...prev, [key]: (prev[key] || 0) + 1 }));
//       }
//       const waNumber = hospital?.whatsapp || "918793608083";
//       const msg = encodeURIComponent(
//         `*${hospital?.name || "Hospital"}* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${waNumber}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: localISO(new Date()),
//         time: "",
//         message: "",
//       });
//       setTimeout(() => fetchSlotCounts(), 1200);
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>
//       <div className="appointment-inner appt-outer">
//         {/* LEFT */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>
//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{hospital?.phone || "+91 87936 08083"}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>
//                   {hospital?.address || "12, Dental Plaza, MG Road"}
//                 </strong>
//                 <span>{hospital?.city || "Pune, Maharashtra 411001"}</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>{hospital?.email || "care@pearlsmiledental.in"}</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* ✅ Doctors Available Today — only shown when hospitalId exists */}
//           {hospital?._id && (
//             <div style={{ marginTop: 28 }}>
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 700,
//                   color: "#1e293b",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 12,
//                 }}
//               >
//                 🩺 Doctors Available Today
//               </div>
//               {!doctorsLoaded ? (
//                 [1, 2, 3].map((i) => (
//                   <div key={i} className="appt-doc-card">
//                     <div
//                       className="appt-skel"
//                       style={{
//                         width: 38,
//                         height: 38,
//                         borderRadius: "50%",
//                         flexShrink: 0,
//                       }}
//                     />
//                     <div style={{ flex: 1 }}>
//                       <div
//                         className="appt-skel"
//                         style={{ width: "60%", height: 13, marginBottom: 6 }}
//                       />
//                       <div
//                         className="appt-skel"
//                         style={{ width: "40%", height: 10 }}
//                       />
//                     </div>
//                     <div
//                       className="appt-skel"
//                       style={{ width: 80, height: 22, borderRadius: 12 }}
//                     />
//                   </div>
//                 ))
//               ) : doctors.length === 0 ? (
//                 <div
//                   style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//                 >
//                   No doctors available yet.
//                 </div>
//               ) : (
//                 doctors.map((doc) => (
//                   <div
//                     key={doc._id}
//                     className="appt-doc-card"
//                     style={{
//                       border: `1px solid ${doc.isAvailable !== false ? "#bbf7d0" : "#fecaca"}`,
//                       background:
//                         doc.isAvailable !== false ? "#f0fdf4" : "#fef2f2",
//                       opacity: doc.isAvailable !== false ? 1 : 0.65,
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: 38,
//                         height: 38,
//                         borderRadius: "50%",
//                         flexShrink: 0,
//                         background: `linear-gradient(135deg,${doc.isAvailable !== false ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: 18,
//                         color: "#fff",
//                         fontWeight: 700,
//                       }}
//                     >
//                       {(doc.name || "D")
//                         .replace(/^Dr\.\s*/i, "")
//                         .charAt(0)
//                         .toUpperCase()}
//                     </div>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <div
//                         style={{
//                           fontWeight: 700,
//                           fontSize: 14,
//                           color:
//                             doc.isAvailable !== false ? "#166534" : "#991b1b",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         {doc.name}
//                       </div>
//                       <div
//                         style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                       >
//                         {doc.specialty || "General Dentist"}
//                       </div>
//                     </div>
//                     <span
//                       style={{
//                         padding: "3px 10px",
//                         borderRadius: 12,
//                         fontSize: 11,
//                         fontWeight: 700,
//                         background:
//                           doc.isAvailable !== false ? "#dcfce7" : "#fee2e2",
//                         color:
//                           doc.isAvailable !== false ? "#16a34a" : "#dc2626",
//                         border: `1px solid ${doc.isAvailable !== false ? "#16a34a" : "#dc2626"}`,
//                         whiteSpace: "nowrap",
//                         flexShrink: 0,
//                       }}
//                     >
//                       {doc.isAvailable !== false
//                         ? "✅ Available"
//                         : "❌ Unavailable"}
//                     </span>
//                   </div>
//                 ))
//               )}
//             </div>
//           )}
//         </div>

//         {/* RIGHT */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   {hospital?.name || "Hospital"} — Book online, confirm via
//                   WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 — Details */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {SERVICES.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="appt-divider" />

//             {/* Step 2 — Date */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>Select Date
//               </div>
//               <div className="appt-date-strip-wrap">
//                 <div className="appt-date-strip" ref={stripRef}>
//                   {DAYS.map((d) => {
//                     const avail = totalAvail(d.iso);
//                     return (
//                       <div
//                         key={d.iso}
//                         className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                         onClick={() => {
//                           set("date", d.iso);
//                           set("time", "");
//                         }}
//                       >
//                         <div className="appt-date-day">{d.short}</div>
//                         <div className="appt-date-avail">{avail} slots</div>
//                       </div>
//                     );
//                   })}
//                 </div>
//                 <div className="appt-date-scroll-hint">
//                   ← scroll for more dates →
//                 </div>
//               </div>
//             </div>
//             <div className="appt-divider" />

//             {/* Step 3 — Time */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>Select Time
//                 Slot
//               </div>
//               <div className="appt-selected-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span>{totalAvail(form.date)} slots available</span>
//               </div>
//               {!slotsLoaded ? (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(4,1fr)",
//                     gap: 8,
//                   }}
//                 >
//                   {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
//                     <div
//                       key={i}
//                       className="appt-skel"
//                       style={{ height: 54, borderRadius: 8 }}
//                     />
//                   ))}
//                 </div>
//               ) : (
//                 TIME_GROUPS.map((group) => {
//                   const avail = group.slots.filter(
//                     (t) => !isDisabled(form.date, t),
//                   ).length;
//                   return (
//                     <div key={group.label}>
//                       <div className="appt-period-hdr">
//                         <span style={{ fontSize: 18 }}>{group.icon}</span>
//                         <span>{group.label}</span>
//                         <span className="appt-period-count">{avail} slots</span>
//                       </div>
//                       <div className="appt-slots-grid">
//                         {group.slots.map((t) => {
//                           const past = isSlotPast(form.date, t);
//                           const full = isFull(form.date, t);
//                           const disabled = past || full;
//                           const sel = form.time === t;
//                           const left = getLeft(form.date, t);
//                           const leftCls = full
//                             ? "full"
//                             : past
//                               ? "past"
//                               : left <= 3
//                                 ? "low"
//                                 : "ok";
//                           return (
//                             <div
//                               key={t}
//                               className={`appt-slot${sel ? " selected" : ""}${disabled ? " disabled" : ""}`}
//                               onClick={() => {
//                                 if (!disabled) set("time", sel ? "" : t);
//                               }}
//                             >
//                               <div className="appt-slot-time">{t}</div>
//                               <div className={`appt-slot-left ${leftCls}`}>
//                                 {past ? "Past" : full ? "Full" : `${left} left`}
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//             <div className="appt-divider" />

//             {/* Step 4 — Message */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>Message
//                 (Optional)
//               </div>
//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />
//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                   }}
//                 >
//                   ✅ Selected: <strong>{selectedLabel}</strong> at{" "}
//                   <strong>{form.time}</strong>
//                   <span
//                     style={{
//                       marginLeft: "auto",
//                       fontSize: 11,
//                       color: "#64748b",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {getLeft(form.date, form.time)} slots remaining
//                   </span>
//                 </div>
//               )}
//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending..." : "Book via WhatsApp →"}
//               </button>
//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

///////////// above is correct code/////////////

// // ============================================================
// // src/components/Appointment.js
// // ✅ Past slots disabled
// // ✅ Hospital doctors shown from DB when hospitalId exists
// // ✅ No doctors shown for PearlSmile (no hospitalId)
// // ✅ Services loaded dynamically from hospital's saved services
// // ============================================================
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import api from "../utils/api";
// import { useHospital } from "../context/HospitalContext";

// const MAX_SLOTS = 10;

// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];
// const ALL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots);

// // ✅ Disable past time slots for today
// function isSlotPast(dateISO, timeStr) {
//   const todayISO = localISO(new Date());
//   if (dateISO !== todayISO) return false;
//   const now = new Date();
//   const [timePart, meridiem] = timeStr.split(" ");
//   const [hourStr, minStr] = timePart.split(":");
//   let hour = parseInt(hourStr);
//   const min = parseInt(minStr);
//   if (meridiem === "PM" && hour !== 12) hour += 12;
//   if (meridiem === "AM" && hour === 12) hour = 0;
//   const slotTime = new Date();
//   slotTime.setHours(hour, min, 0, 0);
//   return slotTime <= now;
// }

// // ✅ Fallback services by specialty (used when no DB services found)
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Other",
//   ],
// };

// const CSS = `
// .appt-outer { display:grid; grid-template-columns:1fr 1.35fr; gap:72px; align-items:start; }
// .appt-left-info { display:flex; flex-direction:column; gap:0; }
// .appt-card { background:#fff; border-radius:20px; box-shadow:0 4px 32px rgba(0,0,0,.08); overflow:hidden; }
// .appt-card-header { background:linear-gradient(135deg,#0a1628 0%,#0d7377 100%); padding:22px 28px 18px; display:flex; align-items:center; gap:12px; }
// .appt-card-header-icon { width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0; }
// .appt-card-header-text { flex:1;min-width:0; }
// .appt-card-title { font-size:16px;font-weight:800;color:#fff;margin:0; }
// .appt-card-sub { font-size:11px;color:rgba(255,255,255,.7);margin-top:2px; }
// .appt-section { padding:20px 24px 0; }
// .appt-section:last-child { padding-bottom:24px; }
// .appt-section-label { font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;margin-bottom:10px;display:flex;align-items:center;gap:6px; }
// .appt-section-label-dot { width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#0d7377,#14a0a5);color:#fff;font-size:9px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
// .appt-divider { height:1px;background:#f1f5f9;margin:0 24px; }
// .appt-form-grid { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
// .appt-inp-wrap { display:flex;flex-direction:column;gap:4px; }
// .appt-inp-wrap.full { grid-column:1/-1; }
// .appt-inp-label { font-size:11px;font-weight:600;color:#475569; }
// .appt-inp { padding:10px 12px;border-radius:8px;border:1.5px solid #e2e8f0;font-size:13px;font-family:"DM Sans",sans-serif;outline:none;transition:border-color .2s;background:#f8fafc;width:100%;box-sizing:border-box; }
// .appt-inp:focus { border-color:#0d7377;background:#fff; }
// .appt-textarea { resize:vertical;min-height:72px; }
// .appt-date-strip-wrap { position:relative; }
// .appt-date-strip { display:flex;gap:0;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;border:1.5px solid #e2e8f0;border-radius:12px;background:#f8fafc;overflow:hidden; }
// .appt-date-strip::-webkit-scrollbar { display:none; }
// .appt-date-pill { flex-shrink:0;scroll-snap-align:start;padding:12px 16px;cursor:pointer;text-align:center;min-width:90px;border-right:1px solid #e2e8f0;transition:background .15s;font-family:"DM Sans",sans-serif; }
// .appt-date-pill:last-child { border-right:none; }
// .appt-date-pill:hover { background:rgba(13,115,119,.05); }
// .appt-date-pill.active { background:#0d7377; }
// .appt-date-day { font-size:13px;font-weight:700;color:#1e293b; }
// .appt-date-avail { font-size:10px;color:#16a34a;font-weight:600;margin-top:3px; }
// .appt-date-pill.active .appt-date-day { color:#fff; }
// .appt-date-pill.active .appt-date-avail { color:rgba(255,255,255,.85); }
// .appt-date-scroll-hint { font-size:10px;color:#94a3b8;margin-top:5px;text-align:right; }
// .appt-selected-date-bar { background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:9px 14px;font-size:13px;font-weight:700;color:#1e293b;margin-bottom:14px;display:flex;align-items:center;justify-content:space-between; }
// .appt-selected-date-bar span { color:#0d7377;font-size:11px;font-weight:600; }
// .appt-period-hdr { display:flex;align-items:center;gap:8px;margin:14px 0 10px;font-size:13px;font-weight:700;color:#1e293b; }
// .appt-period-count { background:#f1f5f9;border:1px solid #e2e8f0;border-radius:20px;padding:2px 10px;font-size:10px;color:#64748b;font-weight:600; }
// .appt-slots-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:8px; }
// .appt-slot { padding:10px 6px;border-radius:8px;border:1.5px solid #0d7377;background:#fff;cursor:pointer;text-align:center;transition:all .15s;font-family:"DM Sans",sans-serif; }
// .appt-slot:hover:not(.disabled) { background:#0d7377;border-color:#0d7377; }
// .appt-slot:hover:not(.disabled) .appt-slot-time,.appt-slot:hover:not(.disabled) .appt-slot-left { color:#fff; }
// .appt-slot.selected { background:#0d7377;border-color:#0d7377; }
// .appt-slot.selected .appt-slot-time,.appt-slot.selected .appt-slot-left { color:#fff; }
// .appt-slot.disabled { border-color:#e2e8f0;background:#f8fafc;cursor:not-allowed;opacity:.4; }
// .appt-slot-time { font-size:12px;font-weight:700;color:#0d7377; }
// .appt-slot.disabled .appt-slot-time { color:#94a3b8;text-decoration:line-through; }
// .appt-slot-left { font-size:9px;margin-top:3px;color:#64748b; }
// .appt-slot-left.full { color:#dc2626;font-weight:700; }
// .appt-slot-left.low  { color:#d97706;font-weight:700; }
// .appt-slot-left.ok   { color:#16a34a;font-weight:600; }
// .appt-slot-left.past { color:#94a3b8;font-style:italic; }
// .appt-submit { width:100%;padding:14px;background:linear-gradient(135deg,#25d366,#128c7e);border:none;border-radius:10px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;font-weight:700;color:#fff;font-family:"DM Sans",sans-serif;transition:opacity .2s;margin-top:4px; }
// .appt-submit:hover { opacity:.92; }
// .appt-submit:disabled { opacity:.6;cursor:not-allowed; }
// @keyframes apptPulse { 0%,100%{opacity:1}50%{opacity:.45} }
// .appt-skel { border-radius:8px;background:#e2e8f0;animation:apptPulse 1.5s ease-in-out infinite; }
// .appt-doc-card { padding:12px 14px;border-radius:12px;display:flex;align-items:center;gap:12px;border:1px solid #e5e7eb;background:#f8fafc;margin-bottom:8px; }
// @media(max-width:1024px){.appt-outer{gap:48px;}}
// @media(max-width:860px){.appt-outer{grid-template-columns:1fr!important;gap:32px!important;}.appt-card{border-radius:16px;}.appt-card-header{padding:18px 20px 14px;}.appt-section{padding:16px 18px 0;}.appt-section:last-child{padding-bottom:18px;}.appt-divider{margin:0 18px;}}
// @media(max-width:600px){.appt-card-header{padding:14px 16px 12px;}.appt-card-title{font-size:14px;}.appt-section{padding:14px 14px 0;}.appt-section:last-child{padding-bottom:16px;}.appt-divider{margin:0 14px;}.appt-form-grid{grid-template-columns:1fr!important;}.appt-date-pill{min-width:72px;padding:10px 10px;}.appt-date-day{font-size:12px;}.appt-slots-grid{grid-template-columns:repeat(3,1fr)!important;gap:6px;}.appt-slot{padding:9px 4px;}.appt-slot-time{font-size:11px;}.appt-submit{font-size:14px;padding:13px;}}
// @media(max-width:380px){.appt-slots-grid{grid-template-columns:repeat(2,1fr)!important;}.appt-card-header-icon{width:34px;height:34px;font-size:16px;}}
// `;

// export default function Appointment({ showToast }) {
//   const { hospital } = useHospital();
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: localISO(new Date()),
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);
//   const [slotCounts, setSlotCounts] = useState({});
//   const [slotsLoaded, setSlotsLoaded] = useState(false);
//   const [servicesList, setServicesList] = useState([]); // ✅ dynamic
//   const stripRef = useRef(null);

//   // ✅ Auto-refresh past slots every minute
//   const [, setTick] = useState(0);
//   useEffect(() => {
//     const t = setInterval(() => setTick((n) => n + 1), 60000);
//     return () => clearInterval(t);
//   }, []);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const getBooked = (date, time) => slotCounts[`${date}|${time}`] || 0;
//   const getLeft = (date, time) =>
//     Math.max(0, MAX_SLOTS - getBooked(date, time));
//   const isFull = (date, time) => getLeft(date, time) === 0;
//   const isDisabled = (date, time) =>
//     isSlotPast(date, time) || isFull(date, time);
//   const totalAvail = (date) =>
//     ALL_SLOTS.filter((t) => !isDisabled(date, t)).length;

//   // ✅ Load services dynamically from this hospital's saved services
//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = hospital?._id || null;
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?._id, hospital?.type]);

//   // ✅ Fetch doctors — only from DB when hospitalId exists
//   useEffect(() => {
//     const hospitalId = hospital?._id || "";
//     if (!hospitalId) {
//       setDoctors([]);
//       setDoctorsLoaded(true);
//       return;
//     }
//     let iv;
//     const go = () => {
//       fetch(
//         `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/doctors?hospitalId=${hospitalId}`,
//       )
//         .then((r) => (r.ok ? r.json() : []))
//         .then((data) => {
//           if (Array.isArray(data)) {
//             setDoctors(data.filter((d) => !d.isAdmin));
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {
//           setDoctorsLoaded(true);
//         });
//     };
//     go();
//     iv = setInterval(go, 30000);
//     return () => clearInterval(iv);
//   }, [hospital?._id]);

//   // ✅ Fetch slot counts filtered by hospitalId
//   const fetchSlotCounts = useCallback(async () => {
//     try {
//       const hospitalId = hospital?._id || "";
//       const url = hospitalId
//         ? `/appointments/slots?hospitalId=${hospitalId}`
//         : `/appointments/slots`;
//       const data = await api.get(url);
//       if (data && typeof data === "object" && !Array.isArray(data))
//         setSlotCounts(data);
//     } catch (_) {
//     } finally {
//       setSlotsLoaded(true);
//     }
//   }, [hospital?._id]);

//   useEffect(() => {
//     fetchSlotCounts();
//     const t = setInterval(fetchSlotCounts, 20000);
//     return () => clearInterval(t);
//   }, [fetchSlotCounts]);

//   useEffect(() => {
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill)
//       pill.scrollIntoView({
//         behavior: "smooth",
//         block: "nearest",
//         inline: "center",
//       });
//   }, [form.date]);

//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     if (form.time && isDisabled(form.date, form.time)) {
//       alert("This time slot is not available. Please choose another.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", {
//         ...form,
//         hospitalId: hospital?._id || null,
//       });
//       if (form.time) {
//         const key = `${form.date}|${form.time}`;
//         setSlotCounts((prev) => ({ ...prev, [key]: (prev[key] || 0) + 1 }));
//       }
//       const waNumber = hospital?.whatsapp || "918793608083";
//       const msg = encodeURIComponent(
//         `*${hospital?.name || "Hospital"}* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${waNumber}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: localISO(new Date()),
//         time: "",
//         message: "",
//       });
//       setTimeout(() => fetchSlotCounts(), 1200);
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>
//       <div className="appointment-inner appt-outer">
//         {/* LEFT */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>
//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{hospital?.phone || "+91 87936 08083"}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>
//                   {hospital?.address || "12, Dental Plaza, MG Road"}
//                 </strong>
//                 <span>{hospital?.city || "Pune, Maharashtra 411001"}</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>{hospital?.email || "care@pearlsmiledental.in"}</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* ✅ Doctors Available Today */}
//           {hospital?._id && (
//             <div style={{ marginTop: 28 }}>
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 700,
//                   color: "#1e293b",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   marginBottom: 12,
//                 }}
//               >
//                 🩺 Doctors Available Today
//               </div>
//               {!doctorsLoaded ? (
//                 [1, 2, 3].map((i) => (
//                   <div key={i} className="appt-doc-card">
//                     <div
//                       className="appt-skel"
//                       style={{
//                         width: 38,
//                         height: 38,
//                         borderRadius: "50%",
//                         flexShrink: 0,
//                       }}
//                     />
//                     <div style={{ flex: 1 }}>
//                       <div
//                         className="appt-skel"
//                         style={{ width: "60%", height: 13, marginBottom: 6 }}
//                       />
//                       <div
//                         className="appt-skel"
//                         style={{ width: "40%", height: 10 }}
//                       />
//                     </div>
//                     <div
//                       className="appt-skel"
//                       style={{ width: 80, height: 22, borderRadius: 12 }}
//                     />
//                   </div>
//                 ))
//               ) : doctors.length === 0 ? (
//                 <div
//                   style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//                 >
//                   No doctors available yet.
//                 </div>
//               ) : (
//                 doctors.map((doc) => (
//                   <div
//                     key={doc._id}
//                     className="appt-doc-card"
//                     style={{
//                       border: `1px solid ${doc.isAvailable !== false ? "#bbf7d0" : "#fecaca"}`,
//                       background:
//                         doc.isAvailable !== false ? "#f0fdf4" : "#fef2f2",
//                       opacity: doc.isAvailable !== false ? 1 : 0.65,
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: 38,
//                         height: 38,
//                         borderRadius: "50%",
//                         flexShrink: 0,
//                         background: `linear-gradient(135deg,${doc.isAvailable !== false ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: 18,
//                         color: "#fff",
//                         fontWeight: 700,
//                       }}
//                     >
//                       {(doc.name || "D")
//                         .replace(/^Dr\.\s*/i, "")
//                         .charAt(0)
//                         .toUpperCase()}
//                     </div>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <div
//                         style={{
//                           fontWeight: 700,
//                           fontSize: 14,
//                           color:
//                             doc.isAvailable !== false ? "#166534" : "#991b1b",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         {doc.name}
//                       </div>
//                       <div
//                         style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                       >
//                         {doc.specialty || "General Dentist"}
//                       </div>
//                     </div>
//                     <span
//                       style={{
//                         padding: "3px 10px",
//                         borderRadius: 12,
//                         fontSize: 11,
//                         fontWeight: 700,
//                         background:
//                           doc.isAvailable !== false ? "#dcfce7" : "#fee2e2",
//                         color:
//                           doc.isAvailable !== false ? "#16a34a" : "#dc2626",
//                         border: `1px solid ${doc.isAvailable !== false ? "#16a34a" : "#dc2626"}`,
//                         whiteSpace: "nowrap",
//                         flexShrink: 0,
//                       }}
//                     >
//                       {doc.isAvailable !== false
//                         ? "✅ Available"
//                         : "❌ Unavailable"}
//                     </span>
//                   </div>
//                 ))
//               )}
//             </div>
//           )}
//         </div>

//         {/* RIGHT */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   {hospital?.name || "Hospital"} — Book online, confirm via
//                   WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   {/* ✅ Dynamic services from this hospital */}
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {servicesList.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div className="appt-divider" />

//             {/* Step 2 */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>Select Date
//               </div>
//               <div className="appt-date-strip-wrap">
//                 <div className="appt-date-strip" ref={stripRef}>
//                   {DAYS.map((d) => {
//                     const avail = totalAvail(d.iso);
//                     return (
//                       <div
//                         key={d.iso}
//                         className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                         onClick={() => {
//                           set("date", d.iso);
//                           set("time", "");
//                         }}
//                       >
//                         <div className="appt-date-day">{d.short}</div>
//                         <div className="appt-date-avail">{avail} slots</div>
//                       </div>
//                     );
//                   })}
//                 </div>
//                 <div className="appt-date-scroll-hint">
//                   ← scroll for more dates →
//                 </div>
//               </div>
//             </div>
//             <div className="appt-divider" />

//             {/* Step 3 */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>Select Time
//                 Slot
//               </div>
//               <div className="appt-selected-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span>{totalAvail(form.date)} slots available</span>
//               </div>
//               {!slotsLoaded ? (
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(4,1fr)",
//                     gap: 8,
//                   }}
//                 >
//                   {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
//                     <div
//                       key={i}
//                       className="appt-skel"
//                       style={{ height: 54, borderRadius: 8 }}
//                     />
//                   ))}
//                 </div>
//               ) : (
//                 TIME_GROUPS.map((group) => {
//                   const avail = group.slots.filter(
//                     (t) => !isDisabled(form.date, t),
//                   ).length;
//                   return (
//                     <div key={group.label}>
//                       <div className="appt-period-hdr">
//                         <span style={{ fontSize: 18 }}>{group.icon}</span>
//                         <span>{group.label}</span>
//                         <span className="appt-period-count">{avail} slots</span>
//                       </div>
//                       <div className="appt-slots-grid">
//                         {group.slots.map((t) => {
//                           const past = isSlotPast(form.date, t);
//                           const full = isFull(form.date, t);
//                           const disabled = past || full;
//                           const sel = form.time === t;
//                           const left = getLeft(form.date, t);
//                           const leftCls = full
//                             ? "full"
//                             : past
//                               ? "past"
//                               : left <= 3
//                                 ? "low"
//                                 : "ok";
//                           return (
//                             <div
//                               key={t}
//                               className={`appt-slot${sel ? " selected" : ""}${disabled ? " disabled" : ""}`}
//                               onClick={() => {
//                                 if (!disabled) set("time", sel ? "" : t);
//                               }}
//                             >
//                               <div className="appt-slot-time">{t}</div>
//                               <div className={`appt-slot-left ${leftCls}`}>
//                                 {past ? "Past" : full ? "Full" : `${left} left`}
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//             <div className="appt-divider" />

//             {/* Step 4 */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>Message
//                 (Optional)
//               </div>
//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />
//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                   }}
//                 >
//                   ✅ Selected: <strong>{selectedLabel}</strong> at{" "}
//                   <strong>{form.time}</strong>
//                   <span
//                     style={{
//                       marginLeft: "auto",
//                       fontSize: 11,
//                       color: "#64748b",
//                       fontWeight: 400,
//                     }}
//                   >
//                     {getLeft(form.date, form.time)} slots remaining
//                   </span>
//                 </div>
//               )}
//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending..." : "Book via WhatsApp →"}
//               </button>
//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

////////////// google link check /////////////
// ============================================================
// src/components/Appointment.js
// ✅ Past slots disabled
// ✅ Hospital doctors shown from DB when hospitalId exists
// ✅ No doctors shown for PearlSmile (no hospitalId)
// ✅ Services loaded dynamically from hospital's saved services
// ============================================================
import React, { useState, useEffect, useCallback, useRef } from "react";
import api from "../utils/api";
import { useHospital } from "../context/HospitalContext";

const MAX_SLOTS = 10;

function localISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function getNext14Days() {
  const days = [];
  for (let i = 0; i < 14; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    const iso = localISO(d);
    const short = d.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
    const full = d.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
    days.push({
      iso,
      short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
      full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
    });
  }
  return days;
}
const DAYS = getNext14Days();

const TIME_GROUPS = [
  {
    label: "Morning",
    icon: "🌅",
    slots: [
      "09:00 AM",
      "09:15 AM",
      "09:30 AM",
      "09:45 AM",
      "10:00 AM",
      "10:15 AM",
      "10:30 AM",
      "10:45 AM",
      "11:00 AM",
      "11:15 AM",
      "11:30 AM",
      "11:45 AM",
    ],
  },
  {
    label: "Afternoon",
    icon: "☀️",
    slots: [
      "12:00 PM",
      "12:15 PM",
      "12:30 PM",
      "12:45 PM",
      "01:00 PM",
      "01:15 PM",
      "01:30 PM",
      "01:45 PM",
      "02:00 PM",
      "02:15 PM",
      "02:30 PM",
      "02:45 PM",
      "03:00 PM",
      "03:15 PM",
      "03:30 PM",
      "03:45 PM",
    ],
  },
  {
    label: "Evening",
    icon: "🌆",
    slots: [
      "04:00 PM",
      "04:15 PM",
      "04:30 PM",
      "04:45 PM",
      "05:00 PM",
      "05:15 PM",
      "05:30 PM",
      "05:45 PM",
      "06:00 PM",
      "06:15 PM",
      "06:30 PM",
      "06:45 PM",
      "07:00 PM",
    ],
  },
];
const ALL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots);

// ✅ Disable past time slots for today
function isSlotPast(dateISO, timeStr) {
  const todayISO = localISO(new Date());
  if (dateISO !== todayISO) return false;
  const now = new Date();
  const [timePart, meridiem] = timeStr.split(" ");
  const [hourStr, minStr] = timePart.split(":");
  let hour = parseInt(hourStr);
  const min = parseInt(minStr);
  if (meridiem === "PM" && hour !== 12) hour += 12;
  if (meridiem === "AM" && hour === 12) hour = 0;
  const slotTime = new Date();
  slotTime.setHours(hour, min, 0, 0);
  return slotTime <= now;
}

// ✅ Fallback services by specialty (used when no DB services found)
const DEFAULT_SERVICES_BY_TYPE = {
  dental: [
    "General Checkup & Cleaning",
    "Cosmetic Dentistry / Smile Makeover",
    "Dental Implants",
    "Orthodontics / Invisalign",
    "Root Canal Therapy",
    "Pediatric Dentistry",
    "Oral Surgery",
    "Periodontal Treatment",
    "Teeth Whitening",
    "Emergency Dental Care",
    "Other",
  ],
  ayurved: [
    "Panchakarma Detox",
    "Shirodhara Therapy",
    "Abhyanga Full Body Massage",
    "Nasya Treatment",
    "Kati Basti Back Pain Relief",
    "Skin & Beauty Treatments",
    "Herbal Consultation",
    "Rasayana Therapy",
    "Yoga & Pranayama",
    "Other",
  ],
  ortho: [
    "Joint Replacement Surgery",
    "Sports Injury Treatment",
    "Knee Replacement",
    "Spine Surgery",
    "Physiotherapy & Rehabilitation",
    "Arthritis Management",
    "Fracture Treatment",
    "Arthroscopy",
    "Post-Op Rehabilitation",
    "Other",
  ],
  eye: [
    "LASIK Laser Eye Surgery",
    "Cataract Surgery",
    "Glaucoma Treatment",
    "Retina Treatment",
    "Squint Correction",
    "Pediatric Ophthalmology",
    "Eye Checkup",
    "Contact Lens Fitting",
    "Other",
  ],
  cardiology: [
    "Coronary Angiography",
    "Angioplasty & Stenting",
    "Open Heart Surgery CABG",
    "Pacemaker Implantation",
    "Preventive Cardiology",
    "Pediatric Cardiology",
    "ECG & Stress Test",
    "Echocardiography",
    "Other",
  ],
  pediatric: [
    "Newborn & Neonatal Care",
    "Vaccination & Immunization",
    "Growth & Development Monitoring",
    "Child Nutrition Counseling",
    "Pediatric Respiratory Care",
    "24/7 Pediatric Emergency",
    "Well Baby Checkup",
    "Other",
  ],
  general: [
    "General Medicine & OPD",
    "Pathology & Diagnostics",
    "Emergency & Trauma Care",
    "Orthopedics & Joint Care",
    "Cardiology & Heart Care",
    "Gynecology & Maternity Care",
    "ENT Treatment",
    "Dermatology",
    "Other",
  ],
};

const CSS = `
.appt-outer { display:grid; grid-template-columns:1fr 1.35fr; gap:72px; align-items:start; }
.appt-left-info { display:flex; flex-direction:column; gap:0; }
.appt-card { background:#fff; border-radius:20px; box-shadow:0 4px 32px rgba(0,0,0,.08); overflow:hidden; }
.appt-card-header { background:linear-gradient(135deg,#0a1628 0%,#0d7377 100%); padding:22px 28px 18px; display:flex; align-items:center; gap:12px; }
.appt-card-header-icon { width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0; }
.appt-card-header-text { flex:1;min-width:0; }
.appt-card-title { font-size:16px;font-weight:800;color:#fff;margin:0; }
.appt-card-sub { font-size:11px;color:rgba(255,255,255,.7);margin-top:2px; }
.appt-section { padding:20px 24px 0; }
.appt-section:last-child { padding-bottom:24px; }
.appt-section-label { font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;margin-bottom:10px;display:flex;align-items:center;gap:6px; }
.appt-section-label-dot { width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#0d7377,#14a0a5);color:#fff;font-size:9px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0; }
.appt-divider { height:1px;background:#f1f5f9;margin:0 24px; }
.appt-form-grid { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
.appt-inp-wrap { display:flex;flex-direction:column;gap:4px; }
.appt-inp-wrap.full { grid-column:1/-1; }
.appt-inp-label { font-size:11px;font-weight:600;color:#475569; }
.appt-inp { padding:10px 12px;border-radius:8px;border:1.5px solid #e2e8f0;font-size:13px;font-family:"DM Sans",sans-serif;outline:none;transition:border-color .2s;background:#f8fafc;width:100%;box-sizing:border-box; }
.appt-inp:focus { border-color:#0d7377;background:#fff; }
.appt-textarea { resize:vertical;min-height:72px; }
.appt-date-strip-wrap { position:relative; }
.appt-date-strip { display:flex;gap:0;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;border:1.5px solid #e2e8f0;border-radius:12px;background:#f8fafc;overflow:hidden; }
.appt-date-strip::-webkit-scrollbar { display:none; }
.appt-date-pill { flex-shrink:0;scroll-snap-align:start;padding:12px 16px;cursor:pointer;text-align:center;min-width:90px;border-right:1px solid #e2e8f0;transition:background .15s;font-family:"DM Sans",sans-serif; }
.appt-date-pill:last-child { border-right:none; }
.appt-date-pill:hover { background:rgba(13,115,119,.05); }
.appt-date-pill.active { background:#0d7377; }
.appt-date-day { font-size:13px;font-weight:700;color:#1e293b; }
.appt-date-avail { font-size:10px;color:#16a34a;font-weight:600;margin-top:3px; }
.appt-date-pill.active .appt-date-day { color:#fff; }
.appt-date-pill.active .appt-date-avail { color:rgba(255,255,255,.85); }
.appt-date-scroll-hint { font-size:10px;color:#94a3b8;margin-top:5px;text-align:right; }
.appt-selected-date-bar { background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:9px 14px;font-size:13px;font-weight:700;color:#1e293b;margin-bottom:14px;display:flex;align-items:center;justify-content:space-between; }
.appt-selected-date-bar span { color:#0d7377;font-size:11px;font-weight:600; }
.appt-period-hdr { display:flex;align-items:center;gap:8px;margin:14px 0 10px;font-size:13px;font-weight:700;color:#1e293b; }
.appt-period-count { background:#f1f5f9;border:1px solid #e2e8f0;border-radius:20px;padding:2px 10px;font-size:10px;color:#64748b;font-weight:600; }
.appt-slots-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:8px; }
.appt-slot { padding:10px 6px;border-radius:8px;border:1.5px solid #0d7377;background:#fff;cursor:pointer;text-align:center;transition:all .15s;font-family:"DM Sans",sans-serif; }
.appt-slot:hover:not(.disabled) { background:#0d7377;border-color:#0d7377; }
.appt-slot:hover:not(.disabled) .appt-slot-time,.appt-slot:hover:not(.disabled) .appt-slot-left { color:#fff; }
.appt-slot.selected { background:#0d7377;border-color:#0d7377; }
.appt-slot.selected .appt-slot-time,.appt-slot.selected .appt-slot-left { color:#fff; }
.appt-slot.disabled { border-color:#e2e8f0;background:#f8fafc;cursor:not-allowed;opacity:.4; }
.appt-slot-time { font-size:12px;font-weight:700;color:#0d7377; }
.appt-slot.disabled .appt-slot-time { color:#94a3b8;text-decoration:line-through; }
.appt-slot-left { font-size:9px;margin-top:3px;color:#64748b; }
.appt-slot-left.full { color:#dc2626;font-weight:700; }
.appt-slot-left.low  { color:#d97706;font-weight:700; }
.appt-slot-left.ok   { color:#16a34a;font-weight:600; }
.appt-slot-left.past { color:#94a3b8;font-style:italic; }
.appt-submit { width:100%;padding:14px;background:linear-gradient(135deg,#25d366,#128c7e);border:none;border-radius:10px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;font-weight:700;color:#fff;font-family:"DM Sans",sans-serif;transition:opacity .2s;margin-top:4px; }
.appt-submit:hover { opacity:.92; }
.appt-submit:disabled { opacity:.6;cursor:not-allowed; }
@keyframes apptPulse { 0%,100%{opacity:1}50%{opacity:.45} }
.appt-skel { border-radius:8px;background:#e2e8f0;animation:apptPulse 1.5s ease-in-out infinite; }
.appt-doc-card { padding:12px 14px;border-radius:12px;display:flex;align-items:center;gap:12px;border:1px solid #e5e7eb;background:#f8fafc;margin-bottom:8px; }
@media(max-width:1024px){.appt-outer{gap:48px;}}
@media(max-width:860px){.appt-outer{grid-template-columns:1fr!important;gap:32px!important;}.appt-card{border-radius:16px;}.appt-card-header{padding:18px 20px 14px;}.appt-section{padding:16px 18px 0;}.appt-section:last-child{padding-bottom:18px;}.appt-divider{margin:0 18px;}}
@media(max-width:600px){.appt-card-header{padding:14px 16px 12px;}.appt-card-title{font-size:14px;}.appt-section{padding:14px 14px 0;}.appt-section:last-child{padding-bottom:16px;}.appt-divider{margin:0 14px;}.appt-form-grid{grid-template-columns:1fr!important;}.appt-date-pill{min-width:72px;padding:10px 10px;}.appt-date-day{font-size:12px;}.appt-slots-grid{grid-template-columns:repeat(3,1fr)!important;gap:6px;}.appt-slot{padding:9px 4px;}.appt-slot-time{font-size:11px;}.appt-submit{font-size:14px;padding:13px;}}
@media(max-width:380px){.appt-slots-grid{grid-template-columns:repeat(2,1fr)!important;}.appt-card-header-icon{width:34px;height:34px;font-size:16px;}}
`;

export default function Appointment({ showToast }) {
  const { hospital } = useHospital();
  const [form, setForm] = useState({
    name: "",
    phone: "",
    service: "",
    date: localISO(new Date()),
    time: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [doctorsLoaded, setDoctorsLoaded] = useState(false);
  const [slotCounts, setSlotCounts] = useState({});
  const [slotsLoaded, setSlotsLoaded] = useState(false);
  const [servicesList, setServicesList] = useState([]); // ✅ dynamic
  const stripRef = useRef(null);

  // ✅ Auto-refresh past slots every minute
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 60000);
    return () => clearInterval(t);
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const getBooked = (date, time) => slotCounts[`${date}|${time}`] || 0;
  const getLeft = (date, time) =>
    Math.max(0, MAX_SLOTS - getBooked(date, time));
  const isFull = (date, time) => getLeft(date, time) === 0;
  const isDisabled = (date, time) =>
    isSlotPast(date, time) || isFull(date, time);
  const totalAvail = (date) =>
    ALL_SLOTS.filter((t) => !isDisabled(date, t)).length;

  // ✅ Load services dynamically from this hospital's saved services
  useEffect(() => {
    const type = (hospital?.type || "dental").toLowerCase();
    const hospitalId = hospital?._id || null;
    const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
    api
      .get(url)
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const names = data.map((s) => s.name);
          if (!names.includes("Other")) names.push("Other");
          setServicesList(names);
        } else {
          setServicesList(
            DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
          );
        }
      })
      .catch(() =>
        setServicesList(
          DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
        ),
      );
  }, [hospital?._id, hospital?.type]);

  // ✅ Fetch doctors — only from DB when hospitalId exists
  useEffect(() => {
    const hospitalId = hospital?._id || "";
    if (!hospitalId) {
      setDoctors([]);
      setDoctorsLoaded(true);
      return;
    }
    let iv;
    const go = () => {
      fetch(
        `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/doctors?hospitalId=${hospitalId}`,
      )
        .then((r) => (r.ok ? r.json() : []))
        .then((data) => {
          if (Array.isArray(data)) {
            setDoctors(data.filter((d) => !d.isAdmin));
            setDoctorsLoaded(true);
          }
        })
        .catch(() => {
          setDoctorsLoaded(true);
        });
    };
    go();
    iv = setInterval(go, 30000);
    return () => clearInterval(iv);
  }, [hospital?._id]);

  // ✅ Fetch slot counts filtered by hospitalId
  const fetchSlotCounts = useCallback(async () => {
    try {
      const hospitalId = hospital?._id || "";
      const url = hospitalId
        ? `/appointments/slots?hospitalId=${hospitalId}`
        : `/appointments/slots`;
      const data = await api.get(url);
      if (data && typeof data === "object" && !Array.isArray(data))
        setSlotCounts(data);
    } catch (_) {
    } finally {
      setSlotsLoaded(true);
    }
  }, [hospital?._id]);

  useEffect(() => {
    fetchSlotCounts();
    const t = setInterval(fetchSlotCounts, 20000);
    return () => clearInterval(t);
  }, [fetchSlotCounts]);

  useEffect(() => {
    if (!stripRef.current) return;
    const idx = DAYS.findIndex((d) => d.iso === form.date);
    if (idx < 0) return;
    const pill = stripRef.current.children[idx];
    if (pill)
      pill.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
  }, [form.date]);

  const handleWhatsApp = async (e) => {
    e.preventDefault();
    if (
      !form.name.trim() ||
      !form.phone.trim() ||
      !form.service ||
      !form.date
    ) {
      alert("Please fill in Name, Phone, Service, and Date.");
      return;
    }
    if (form.time && isDisabled(form.date, form.time)) {
      alert("This time slot is not available. Please choose another.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/appointments", {
        ...form,
        hospitalId: hospital?._id || null,
      });
      if (form.time) {
        const key = `${form.date}|${form.time}`;
        setSlotCounts((prev) => ({ ...prev, [key]: (prev[key] || 0) + 1 }));
      }
      const waNumber = hospital?.whatsapp || "918793608083";
      const msg = encodeURIComponent(
        `*${hospital?.name || "Hospital"}* — New Appointment Request\n\n` +
          `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
          `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
          (form.message ? `*Message:* ${form.message}` : ""),
      );
      window.open(`https://wa.me/${waNumber}?text=${msg}`, "_blank");
      showToast?.("✅ Appointment sent via WhatsApp!");
      setForm({
        name: "",
        phone: "",
        service: "",
        date: localISO(new Date()),
        time: "",
        message: "",
      });
      setTimeout(() => fetchSlotCounts(), 1200);
    } catch (err) {
      showToast?.("❌ " + err.message);
    }
    setSubmitting(false);
  };

  const selectedDay = DAYS.find((d) => d.iso === form.date);
  const selectedLabel = selectedDay?.full || form.date;

  return (
    <section className="appointment" id="appointment">
      <style>{CSS}</style>
      <div className="appointment-inner appt-outer">
        {/* LEFT */}
        <div className="appt-left-info">
          <div className="section-tag">Book Appointment</div>
          <h2 className="section-title">
            Let's Fix Your
            <br />
            <em>Smile Today</em>
          </h2>
          <p className="section-desc">
            Pick a date and time that suits you. We'll confirm your appointment
            via WhatsApp within 30 minutes.
          </p>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <div>
                <strong>{hospital?.phone || "+91 87936 08083"}</strong>
                <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <div>
                <strong>
                  {hospital?.address || "12, Dental Plaza, MG Road"}
                </strong>
                <span>{hospital?.city || "Pune, Maharashtra 411001"}</span>
                {/* ✅ Get Directions — only shown when googleMapsUrl is set */}
                {hospital?.googleMapsUrl && (
                  <a
                    href={hospital.googleMapsUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "flex",
                      width: "fit-content",
                      alignItems: "center",
                      gap: 5,
                      marginTop: 6,
                      background: "linear-gradient(135deg,#0d7377,#14a0a5)",
                      color: "#fff",
                      borderRadius: 7,
                      padding: "5px 12px",
                      fontSize: 11,
                      fontWeight: 700,
                      textDecoration: "none",
                      letterSpacing: "0.2px",
                    }}
                  >
                    🗺️ Get Directions
                  </a>
                )}
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div>
                <strong>{hospital?.email || "care@pearlsmiledental.in"}</strong>
                <span>Response within 2 hours</span>
              </div>
            </div>
          </div>

          {/* ✅ Doctors Available Today */}
          {hospital?._id && (
            <div style={{ marginTop: 28 }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#1e293b",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: 12,
                }}
              >
                🩺 Doctors Available Today
              </div>
              {!doctorsLoaded ? (
                [1, 2, 3].map((i) => (
                  <div key={i} className="appt-doc-card">
                    <div
                      className="appt-skel"
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        flexShrink: 0,
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <div
                        className="appt-skel"
                        style={{ width: "60%", height: 13, marginBottom: 6 }}
                      />
                      <div
                        className="appt-skel"
                        style={{ width: "40%", height: 10 }}
                      />
                    </div>
                    <div
                      className="appt-skel"
                      style={{ width: 80, height: 22, borderRadius: 12 }}
                    />
                  </div>
                ))
              ) : doctors.length === 0 ? (
                <div
                  style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
                >
                  No doctors available yet.
                </div>
              ) : (
                doctors.map((doc) => (
                  <div
                    key={doc._id}
                    className="appt-doc-card"
                    style={{
                      border: `1px solid ${doc.isAvailable !== false ? "#bbf7d0" : "#fecaca"}`,
                      background:
                        doc.isAvailable !== false ? "#f0fdf4" : "#fef2f2",
                      opacity: doc.isAvailable !== false ? 1 : 0.65,
                    }}
                  >
                    <div
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        flexShrink: 0,
                        background: `linear-gradient(135deg,${doc.isAvailable !== false ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 18,
                        color: "#fff",
                        fontWeight: 700,
                      }}
                    >
                      {(doc.name || "D")
                        .replace(/^Dr\.\s*/i, "")
                        .charAt(0)
                        .toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: 14,
                          color:
                            doc.isAvailable !== false ? "#166534" : "#991b1b",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {doc.name}
                      </div>
                      <div
                        style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
                      >
                        {doc.specialty || "General Dentist"}
                      </div>
                    </div>
                    <span
                      style={{
                        padding: "3px 10px",
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 700,
                        background:
                          doc.isAvailable !== false ? "#dcfce7" : "#fee2e2",
                        color:
                          doc.isAvailable !== false ? "#16a34a" : "#dc2626",
                        border: `1px solid ${doc.isAvailable !== false ? "#16a34a" : "#dc2626"}`,
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }}
                    >
                      {doc.isAvailable !== false
                        ? "✅ Available"
                        : "❌ Unavailable"}
                    </span>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* RIGHT */}
        <div style={{ minWidth: 0, width: "100%" }}>
          <div className="appt-card">
            <div className="appt-card-header">
              <div className="appt-card-header-icon">🏥</div>
              <div className="appt-card-header-text">
                <div className="appt-card-title">Clinic Visit Slots</div>
                <div className="appt-card-sub">
                  {hospital?.name || "Hospital"} — Book online, confirm via
                  WhatsApp
                </div>
              </div>
            </div>

            {/* Step 1 */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">1</span>Your Details
              </div>
              <div className="appt-form-grid">
                <div className="appt-inp-wrap">
                  <label className="appt-inp-label">Full Name *</label>
                  <input
                    className="appt-inp"
                    type="text"
                    placeholder="e.g. Riya Sharma"
                    value={form.name}
                    onChange={(e) => set("name", e.target.value)}
                  />
                </div>
                <div className="appt-inp-wrap">
                  <label className="appt-inp-label">Phone Number *</label>
                  <input
                    className="appt-inp"
                    type="tel"
                    placeholder="+91 98765 43210"
                    value={form.phone}
                    onChange={(e) => set("phone", e.target.value)}
                  />
                </div>
                <div className="appt-inp-wrap full">
                  <label className="appt-inp-label">Service Required *</label>
                  {/* ✅ Dynamic services from this hospital */}
                  <select
                    className="appt-inp"
                    value={form.service}
                    onChange={(e) => set("service", e.target.value)}
                  >
                    <option value="">— Select a service —</option>
                    {servicesList.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="appt-divider" />

            {/* Step 2 */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">2</span>Select Date
              </div>
              <div className="appt-date-strip-wrap">
                <div className="appt-date-strip" ref={stripRef}>
                  {DAYS.map((d) => {
                    const avail = totalAvail(d.iso);
                    return (
                      <div
                        key={d.iso}
                        className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
                        onClick={() => {
                          set("date", d.iso);
                          set("time", "");
                        }}
                      >
                        <div className="appt-date-day">{d.short}</div>
                        <div className="appt-date-avail">{avail} slots</div>
                      </div>
                    );
                  })}
                </div>
                <div className="appt-date-scroll-hint">
                  ← scroll for more dates →
                </div>
              </div>
            </div>
            <div className="appt-divider" />

            {/* Step 3 */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">3</span>Select Time
                Slot
              </div>
              <div className="appt-selected-date-bar">
                <strong>{selectedLabel}</strong>
                <span>{totalAvail(form.date)} slots available</span>
              </div>
              {!slotsLoaded ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4,1fr)",
                    gap: 8,
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                    <div
                      key={i}
                      className="appt-skel"
                      style={{ height: 54, borderRadius: 8 }}
                    />
                  ))}
                </div>
              ) : (
                TIME_GROUPS.map((group) => {
                  const avail = group.slots.filter(
                    (t) => !isDisabled(form.date, t),
                  ).length;
                  return (
                    <div key={group.label}>
                      <div className="appt-period-hdr">
                        <span style={{ fontSize: 18 }}>{group.icon}</span>
                        <span>{group.label}</span>
                        <span className="appt-period-count">{avail} slots</span>
                      </div>
                      <div className="appt-slots-grid">
                        {group.slots.map((t) => {
                          const past = isSlotPast(form.date, t);
                          const full = isFull(form.date, t);
                          const disabled = past || full;
                          const sel = form.time === t;
                          const left = getLeft(form.date, t);
                          const leftCls = full
                            ? "full"
                            : past
                              ? "past"
                              : left <= 3
                                ? "low"
                                : "ok";
                          return (
                            <div
                              key={t}
                              className={`appt-slot${sel ? " selected" : ""}${disabled ? " disabled" : ""}`}
                              onClick={() => {
                                if (!disabled) set("time", sel ? "" : t);
                              }}
                            >
                              <div className="appt-slot-time">{t}</div>
                              <div className={`appt-slot-left ${leftCls}`}>
                                {past ? "Past" : full ? "Full" : `${left} left`}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <div className="appt-divider" />

            {/* Step 4 */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">4</span>Message
                (Optional)
              </div>
              <textarea
                className="appt-inp appt-textarea"
                placeholder="Describe your concern…"
                value={form.message}
                onChange={(e) => set("message", e.target.value)}
              />
              {form.time && (
                <div
                  style={{
                    marginTop: 12,
                    padding: "10px 14px",
                    borderRadius: 8,
                    background: "rgba(13,115,119,.06)",
                    border: "1px solid rgba(13,115,119,.2)",
                    fontSize: 12,
                    color: "#0d7377",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  ✅ Selected: <strong>{selectedLabel}</strong> at{" "}
                  <strong>{form.time}</strong>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: 11,
                      color: "#64748b",
                      fontWeight: 400,
                    }}
                  >
                    {getLeft(form.date, form.time)} slots remaining
                  </span>
                </div>
              )}
              <button
                className="appt-submit"
                onClick={handleWhatsApp}
                disabled={submitting}
                style={{ marginTop: 14 }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                  <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
                </svg>
                {submitting ? "Sending..." : "Book via WhatsApp →"}
              </button>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 10,
                  fontSize: 11,
                  color: "#94a3b8",
                }}
              >
                You'll receive a confirmation call/WhatsApp within 30 minutes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
